import { Page } from '../../types/website.types';
import ImageWithErrorHandling from '../../components/image/ImageWithErrorHandling';
import { getPartition, stripHtmlTags } from '../../utils/utils';
import { DateCell } from '../../components/tables/cellComponents/DateCell';

export interface BlogCardProps {
  page: Page;
}

export const BlogCard: React.FC<BlogCardProps> = ({ page }) => {
  return (
    <a href={`/sticky-notes/${page.slug}`} className="link-block-card">
      <div className="div-blog-card">
        <div className="div-blog-card-image-wrapper">
          <ImageWithErrorHandling
            className="sticky-note-card-image"
            alt={page.name}
            src={`${page?.s3_base_url}/${getPartition(page?.id)}/medium/${page?.image_file_name}`}
          />
        </div>
        <div className="div-blog-card-details">
          <div>
            <div className="subheader blog-card"><DateCell date={page.published_on}/></div>
            <div className="blog-card-title">{page.name}</div>
          </div>
          <div>
            <div className="text-block-product">{`by ${page.author}`}</div>
            <div className="text-available">
              {stripHtmlTags(page.content).slice(0, 72)}...
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};
